import { useState, useRef, useEffect } from 'react'
import { Globe, ChevronDown } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { PATIENT_LANGUAGES as LANGUAGES } from '../data/patientLanguages'

export function LanguageSelector() {
  const { i18n } = useTranslation()
  const [open, setOpen] = useState(false)
  const ref = useRef<HTMLDivElement>(null)

  const current = LANGUAGES.find(l => l.code === i18n.language) || LANGUAGES[0]

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  const handleSelect = (code: string) => {
    i18n.changeLanguage(code)
    setOpen(false)
  }

  return (
    <div className="flex justify-end px-4 pt-4" ref={ref}>
      <div className="relative">
        <button
          className="flex items-center gap-2 text-muted-foreground text-small hover:text-foreground transition-colors"
          onClick={() => setOpen(!open)}
        >
          <Globe className="w-4 h-4" />
          <span>{current.label}</span>
          <ChevronDown className="w-4 h-4" />
        </button>

        {open && (
          <div className="absolute right-0 top-full mt-1 bg-white rounded-card shadow-lg border border-border py-1 z-50 min-w-[140px]">
            {LANGUAGES.map(lang => (
              <button
                key={lang.code}
                onClick={() => handleSelect(lang.code)}
                className={`w-full px-3 py-2 text-left text-small hover:bg-muted flex items-center gap-2 ${
                  lang.code === i18n.language ? 'font-medium text-foreground' : 'text-muted-foreground'
                }`}
              >
                <span>{lang.flag}</span>
                <span>{lang.label}</span>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
